import { render } from "./GetParticipantsListStatsSimple.vue?vue&type=template&id=20c133fd"
import script from "./GetParticipantsListStatsSimple.vue?vue&type=script&lang=js"
export * from "./GetParticipantsListStatsSimple.vue?vue&type=script&lang=js"

import "./GetParticipantsListStatsSimple.vue?vue&type=style&index=0&id=20c133fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__